import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../../../components/loading/loading";
import { Col, Row } from "antd";
import INPUT from './../../../../components/input/input';
import BUTTON from "./../../../../components/buttons/button";
import { color } from "./../../../../utils/themes/color";

export default function SizeAthlete(props) {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState([]);


    useEffect(() => {
        setLoading(true)
        Axios.get(`${url}users/athlete-get-size-of-organs/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setUser(response.data)
                    setLoading(false)
                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [])

    const updateSizeOfOrgans = () => {

        if (user.aroundTheNeck != "" && user.aroundTheNeck != null && user.aroundTheShoulder != "" && user.aroundTheShoulder != null && user.aroundTheArm != ""  && user.aroundTheArm != null && user.aroundTheForearm != ""  && user.aroundTheForearm != null && user.aroundTheHandWrist != "" && user.aroundTheHandWrist != null  && user.aroundTheFootWrist != "" && user.aroundTheFootWrist != null && user.aroundTheChest != "" && user.aroundTheChest != null && user.aroundTheWaist != "" && user.aroundTheWaist != null  && user.aroundTheHips != "" && user.aroundTheHips != null && user.aroundTheThigh != "" && user.aroundTheThigh != null && user.aroundTheLeg != "" && user.aroundTheLeg != null) {
        setLoading(true)
        Axios.patch(`${url}users/athlete-size-of-organs/${userId}`, user)
            .then(async (response) => {
                if (response.status === 200 || response.status === 201) {

                    GreenNotif(response.message);
                    setLoading(false)
                    props.pager(2)
                } else {
                    RedNotif(response.message);
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                console.log("error", error)
                setLoading(false)
            });
            
        } else {
            RedNotif("لطفا تمام موارد را وارد کنید هیچ فیلدی نباید خالی باشد")
        }
        }


    switch (loading) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
        <>
            <Row style={{ marginBottom: '18px' }}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                    <p>اطلاعات زیر را وارد نمایید:</p>
                </Col>
            </Row>

            <Row style={{ marginRight: '8px' }} gutter={20}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>گردن:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheNeck": parseInt(e) })}
                        value={user.aroundTheNeck != undefined && user.aroundTheNeck != null && user.aroundTheNeck != "0" ? user.aroundTheNeck : ""}


                    />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور شانه:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                    type={"number"}
                    placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheShoulder": parseInt(e) })}
                        value={user.aroundTheShoulder != undefined && user.aroundTheShoulder != null && user.aroundTheShoulder != "0" ? user.aroundTheShoulder : ""}
                    />
                </Col>
            </Row>

            <Row style={{ marginRight: '8px' }} gutter={20}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور بازو:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheArm": parseInt(e) })}
                        value={user.aroundTheArm != undefined && user.aroundTheArm != null && user.aroundTheArm != "0" ? user.aroundTheArm : ""}

                    />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>ساعد:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheForearm": parseInt(e) })}
                        value={user.aroundTheForearm != undefined && user.aroundTheForearm != null && user.aroundTheForearm != "0" ? user.aroundTheForearm : ""}
                    />
                </Col>
            </Row>

            <Row style={{ marginRight: '8px' }} gutter={20}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>مچ دست:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheHandWrist": parseInt(e) })}
                        value={user.aroundTheHandWrist != undefined && user.aroundTheHandWrist != null && user.aroundTheHandWrist != "0" ? user.aroundTheHandWrist : ""}

                    />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور سینه:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheChest": parseInt(e) })}
                        value={user.aroundTheChest != undefined && user.aroundTheChest != null && user.aroundTheChest != "0" ? user.aroundTheChest : ""}
                    />
                </Col>
            </Row>
            
            <Row style={{ marginRight: '8px' }} gutter={20}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور کمر:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheWaist": parseInt(e) })}
                        value={user.aroundTheWaist != undefined && user.aroundTheWaist != null && user.aroundTheWaist != "0" ? user.aroundTheWaist : ""}

                    />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور باسن:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheHips": parseInt(e) })}
                        value={user.aroundTheHips != undefined && user.aroundTheHips != null && user.aroundTheHips != "0" ? user.aroundTheHips : ""}
                    />
                </Col>
            </Row>

            <Row style={{ marginRight: '8px' }} gutter={20}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور ران:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheThigh": parseInt(e) })}
                        value={user.aroundTheThigh != undefined && user.aroundTheThigh != null && user.aroundTheThigh != "0" ? user.aroundTheThigh : ""}

                    />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور ساق پا:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheLeg": parseInt(e) })}
                        value={user.aroundTheLeg != undefined && user.aroundTheLeg != null && user.aroundTheLeg != "0" ? user.aroundTheLeg : ""}
                    />
                </Col>
            </Row>

            <Row style={{ marginRight: '8px' }} gutter={20}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                    <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                        <p>دور مچ پا:</p>
                        <p style={{ color: color.mandatoryColor }}>*</p>                    </div>
                    <INPUT
                        type={"number"}
                        placeholder="سانتی متر"
                        i={(e) => setUser({ ...user, "aroundTheFootWrist": parseInt(e) })}
                        value={user.aroundTheFootWrist != undefined && user.aroundTheFootWrist != null && user.aroundTheFootWrist != "0" ? user.aroundTheFootWrist : ""}

                    />
                </Col>

            </Row>

            <Row style={{ marginTop: '42px' }} gutter={20}>
                <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                    <BUTTON event={(e) => updateSizeOfOrgans()} text="ثبت و بعدی" type={"submit"} loading={loading} />
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                    <BUTTON event={(e) =>  props.pager(2)} text="رد کردن" type={"cancel"} />

                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
            </Row>
        </>
        )
        }

}